import { connect } from 'react-redux';
import { selectAllCoursesFilterData } from 'src/ReduxStorage/InstitutionAdminSettings/selectors';
import { selectCurrentInstitutionPath } from 'src/ReduxStorage/Institutions/CurrentInstitutionPath/selectors';
import { ReduxState } from 'src/ReduxStorage/state';
import { RecentlyAddedMembers } from './component';

export const ConnectedRecentlyAddedMembers = connect((state: ReduxState) => ({
  currentInstitutionPath: selectCurrentInstitutionPath(state),
  allCoursesFilterData: selectAllCoursesFilterData(state),
}))(RecentlyAddedMembers);
